<template>
  <div>
    <transition name="fade">
      <div v-if="aboutus">
        <p class="text-6xl font-bold text-red-500 p1">{{ $t("AboutUs") }}</p>
      </div>
    </transition>
    <transition name="slide-fade">
      <div class="p-4" v-if="wetext">
        <p class="text-4xl p2">{{ $t("AboutWeareText") }}</p>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      toptext: "This is Top Text",
      aboutus: false,
      wetext: false
    };
  },
  created() {
    setTimeout(() => {
      this.aboutus = true;
    }, 500);
    setTimeout(() => {
      this.wetext = true;
    }, 2000);
  }
};
</script>

<style lang="stylus" scoped>
.p1 {
  color: red;
}

.p2 {
  color: black;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 2s;
}
</style>